//INIT
import { useEffect, useState } from "react"

//FUNCTIONS \ REQUESTS

import {} from "../../pages/RegistradorDePedidos/functions"

import {} from "../../services/functionsGerais"

import {} from "../../services/comum"

import {} from "../../services/cliente"

//FRAMEWORK
import { useMediaQuery, useTheme } from "@material-ui/core"
import Container from "@material-ui/core/Container"
import { useSnackbar } from "notistack"
import { RegistrarLogErro } from "../../services/clientefiel"
import { buscarestabelecimentos } from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Loading from "../Componentes/Loading"
import CardapioNovo from "./Cardapionovo"

export default function Cardapio() {
    const autorizacao = localStorage.getItem("chaveSistema")
    const configs = useAppStore(s => s.configuracoes)
    const loading = useLoadingStore(s => s.loading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const [state, setState] = useState({
        estabelecimentos: [],
        estabelecimento: {},
        cardapio: [],
    })

    const handleBuscarDadosEstabelecimentos = async () => {
        let estabelecimentos = []
        let estabelecimento = {}

        try {
            const response = await buscarestabelecimentos(autorizacao)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")

                setState({
                    ...state,
                    loading: false,
                })
            } else {
                estabelecimentos = response

                if (response.length === 1) {
                    estabelecimento = response[0]
                } else if (response.length > 1) {
                    estabelecimento = response.filter(
                        e => e.id === configs.user.parametros.estabelecimento.id
                    )[0]
                }

                setState({
                    ...state,
                    estabelecimentos: estabelecimentos,
                    estabelecimento: estabelecimento,
                    loading: false,
                })

                return response
            }
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
            alertStart(error, "error")
        }
        return {}
    }

    useEffect(() => {
        handleBuscarDadosEstabelecimentos()
    }, [])

    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <Container className="container-buscando">
            <Loading loading={loading} />

            <div
                style={{
                    textAlign: "center",
                    paddingTop: mobile ? "" : "4.8rem",
                    marginLeft: mobile ? "" : "80px",
                }}
            >
                {state?.estabelecimento?.id ? (
                    <CardapioNovo estabelecimento={state.estabelecimento} />
                ) : null}
            </div>
        </Container>
    )
}
